import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import axios from "axios";
import { BaseUrl } from "../helper/BaseUrl";

const ProtectedRoute = ({ children }) => {
  const [authenticated, setAuthenticated] = useState(null);
  useEffect(() => {
    const accessToken = localStorage.getItem("accessTokenBigbin");
    axios.get(`${BaseUrl}api/rbac/my-permissions`, {
      headers: {
        "x-access-token": accessToken,
        "x-session-check": "true",
      },
    })
      .then(() => setAuthenticated(true))
      .catch(() => {
        localStorage.removeItem("accessTokenBigbin");
        setAuthenticated(false);
      });
  }, []);
  if (authenticated === null) return <div>Loading...</div>;
  return authenticated ? children : <Navigate to="/login" replace />;
};

export default ProtectedRoute;
